import React from 'react';

import { Languages } from '../components/languages';
import { ajax, plainDate, myDeepCopy, showErrorPopup, getNavigation, downloadCsv } from '../components/globals';
import { ModalBox, UButtonFlat, UListButtonFlat, UGrandTotals, UInputFlat, UItemsList, UTitle, UTitleFlat, ULabelFlat, USelectFlat, UDateFlat } from '../components/utilities';
import { UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIMultiSelect } from '../components/guiElements';


/* section, title, filters{name:{width, text, colClass, class, type}}, data{name:value}, onChange, onClick
*/
/*
class CountersignsFilters extends React.Component {
    render() {
        const items = Object.entries(this.props.filters).map(([key, val]) => (
            (key === 'button') ? (
                <UButtonFlat key={key} colClass={val.colClass} width={val.width} type={val.class} text={val.text} onClick={this.props.onClick} />
            ) : (
                    (val.type === "date") ? (
                        <UDateFlat maxDate={new Date()} key={key} name={key} source={this.props.section} width={val.width} colClass={val.colClass}
                            itemClass={val.class} text={val.text} value={this.props.data[key]} onChange={this.props.onChange} />
                    ) : (
                            <UInputFlat key={key} name={key} source={this.props.section} width={val.width} colClass={val.colClass}
                                itemClass={val.class} type={val.type} text={val.text} value={this.props.data[key]} onChange={this.props.onChange} />
                        )
                )
        ), this);
        return (
            <div className="container-fluid countersigns-filters">
                <UTitle colClass="no-padding" textClass="bold upper" text={this.props.title} />
                <div className="row countersigns-filters">{items}</div>
            </div>
        );
    }
}*/


export default class Countersigns extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.filtersChange = this.filtersChange.bind(this);
        //this.filterClick = this.filterClick.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.listChange = this.listChange.bind(this);
        this.listClick = this.listClick.bind(this);
        this.modalChange = this.modalChange.bind(this);
        //this.changePageSize = this.changePageSize.bind(this);
        //this.changePageNo = this.changePageNo.bind(this);
        this.getData = this.getData.bind(this);
        // inline manage  this.modalClick = this.modalClick.bind(this);
        //#endregion Methods binding

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.Countersigns[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.configs = {
            filters: {
                dateFrom: { idx: 0, width: "11%", text: this.le.filters.inputs[0], colClass: 'uinputflat u-lift', class: null, type: "date" },
                dateTo: { idx: 0, width: "11%", text: this.le.filters.inputs[1], colClass: 'uinputflat u-lift', class: null, type: "date" },
                orderNo: { idx: 1, width: "21%", text: this.le.filters.inputs[2], colClass: 'u-lift', class: null, type: "text" },
                response: { idx: 2, width: "19%", text: this.le.filters.inputs[3], colClass: 'u-lift', class: null, type: "text" },
                //button: { idx: 3, width: "17%", text: this.le.filters.button, colClass: 'col ubutton thin left', class: 'filter', type: "text" }
            }
        };

        this.header = [
            {
                generic: { manage: 0, default: false, name: 'main', width: 5, change: null, click: null },
                caption: { type: 'hidden', colClass: null, itemClass: null, value: null },
                element: { type: 'hidden', colClass: null, itemClass: null, options: null }
            },
            //{
            //    generic: { manage: 1, default: false, name: 'main', width: 5, change: this.listChange, click: null },
            //    caption: { type: 'checkbox', colClass: null, itemClass: null, value: null },
             //   element: { type: 'checkbox', colClass: null, itemClass: null, options: null }
            //}, 
            {
                generic: { manage: 0, name: 'date', width: 11, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'orderNo', width: 18, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'courier', width: 10, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'response', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 2, default: null, name: 'action', width: 15, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list.captions[4] },
                element: { type: 'button', colClass: 'center', itemClass: 'modify', options: this.le.list.listButton }
            }];
        this.listKey = 0;

        //#region Automatic Support Data
        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => { if (key !== "button") filters[key] = ""; });
        //#endregion Automatic Support Data

        this.appliedFilters = filters;
        this.state = {
            filters: this.appliedFilters,
            markList:[],
            entries: [],
            managers: Array(1).fill().map(() => (this.defaultManager.slice())),
            totals: [],
            modalType: 0,
            modalReference: "",
            modalState: ""
        };
    }

    //#region Data functions

    getData(navigation) {
        try {
            const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
            this.props.loaderShow(0);
            const url = '/api/mark/mark/' + navigation.pageNo.value + '/' + navigation.pageSize.value + '/' + filters;
            ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {

                    this.props.loaderHide();

                    //let entries = this.props.entries;
                    let markList = response.data.result.marks;
                    let entries = response.data.result.marks.map(el => ([
                        el.id, plainDate(el.orderDate), el.orderNum, el.carrierSign,
                        this.le.states.hasOwnProperty(el.status) ? this.le.states[el.status] : el.status,
                        el.modifiable
                    ]));
                    navigation.totalItems.value = response.data.result.totItems;
                    let totals = [
                        { name: 'cashed', val: response.data.result.totals.cashed },
                        { name: 'carrierCashed', val: response.data.result.totals.carrierCashed },
                        { name: 'cashIn', val: response.data.result.totals.cashIn }
                        
                    ];

                    this.setState({
                        entries: entries,
                        markList: markList,
                        managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                        navigation: navigation,
                        totals: totals
                    });
                },
                error => {
                    this.props.loaderHide();
                    /*const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                    let obj = {
                        title: msg.title,
                        width: "35%",
                        icon: "error",
                        messages: [error.message],
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                    };
                    this.props.popUp(obj);*/

                    this.props.popupErrorMessage(error.message);
                }
            );
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    //#endregion Data functions

    //#region Events

    componentDidMount() {
       
        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.getData(navigation);
        
    }

    filtersChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value; 
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = JSON.parse(JSON.stringify(newFilters));
            let newNavig = myDeepCopy(this.state.navigation);
            newNavig.pageNo.value = 0;
            this.getData(newNavig);
        }
    }

    /*filterClick(ev) {
        //alert(`Filter`);
        if (JSON.stringify(this.state.filters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = JSON.parse(JSON.stringify(this.state.filters));

            let newNavig = myDeepCopy(this.state.navigation);
            newNavig.pageNo.value = 0;
            this.getData(newNavig);
        }
    }*/

    downloadExcel(ev, data) {
        try {

            downloadCsv(this.uc.jwtToken,'mark', this.state.navigation.pageNo.value, this.state.navigation.pageSize.value,
                this.state.filters,
                error => {

                    const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                    /*let obj = {
                        title: msg.title,
                        width: "35%",
                        icon: "error",
                        messages: msg.messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                    };
                    this.props.popUp(obj);*/

                    this.props.popupErrorMessage(msg.messages);

                }, this);


        }
        catch (e) {
            const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
            /*let obj = {
                title: msg.title,
                width: "35%",
                icon: "error",
                messages: msg.messages,
                buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
            };
            this.props.popUp(obj);*/
            this.props.popupErrorMessage(msg.messages);
        }
    }

    listChange(ev, name, value, source) {
        //alert(`Change name: ${name}, value: ${value}, source: ${source}`);
        let managers = JSON.parse(JSON.stringify(this.state.managers)), entries = JSON.parse(JSON.stringify(this.state.entries));
        const row = (source === "##header##" ? -1 : entries.findIndex((el) => (el[this.listKey] === source))), col = this.dataIndexes.find((el) => (el.name === name));
        if (col.manage > 0) {
            if (name === "main" && row === -1) {
                managers = managers.map(function (el) {
                    el[col.idx] = value;
                    return el;
                });
            }
            else managers[row + 1][col.idx] = value;
            this.setState({ managers: managers });
        }
        else {
            entries[row][col.idx] = value;
            this.setState({ entries: entries });
        }
    }

    listClick(ev) {
        //alert(`Click name: ${name}, value: ${value}, source: ${source}`);
        this.setState({ modalType: 1, modalState: Object.keys(this.le.states)[0], modalReference: ev.target.value });  // modelState set to a default value
    }

    modalChange(ev) {
        this.setState({ modalState: ev.target.value });
    }

    modalClick(ev, data) {
        if (data) //alert(`Modal click: ${data}, source ${this.state.modalReference}, changes status to ${this.state.modalState}`);
        {
            try {
                this.setState({ modalType: 0 });
                this.props.loaderShow(0);
                let id = encodeURIComponent(this.state.modalReference);
                let status = encodeURIComponent(this.state.modalState);
                
                ajax(this, { method: 'post', url: 'api/mark/change-status/' + id + '/' + status, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                    ok => {
                        this.props.loaderHide();
                        this.setState({ modalType: 0, modalState: "", modalReference: "" });
                        this.getData(this.state.navigation);
                    },
                    error => {
                        this.props.loaderHide();
                        this.setState({ modalType: 0,});
                        const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                        /*let obj = {
                            title: msg.title,
                            width: "35%",
                            icon: "error",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                        };
                        this.props.popUp(obj);*/

                        this.props.popupErrorMessage(msg.messages);

                    });
            }
            catch (e)
            {
                this.props.loaderHide();
            }
        }
        else
            this.setState({ modalType: 0, modalState: "", modalReference: "" });
        
    }
    /*
    changePageSize(ev, vl) {
        let newNavig = myDeepCopy(this.state.navigation);
        const offset = newNavig.pageNo.value * newNavig.pageSize.value;
        newNavig.pageNo.value = Math.round(offset / vl);
        newNavig.pageSize.value = vl;
        this.getData(newNavig);
    }

    changePageNo(ev, vl) {
        let newNavig = myDeepCopy(this.state.navigation);
        newNavig.pageNo.value = vl;
        this.getData(newNavig);
    }*/

    //#endregion Events

    render() {
        //#region Data Structures
        const btnData = { name: "excelDownload", source: this.constructor.name, type: "confirm", text: this.le.list.button };
        const totals = this.state.totals.map((el, idx) => (
            <UISummaryWidget key={"sum-" + idx} className="" title={this.le.card.entries[el.name].text} hint={this.le.card.entries[el.name].subText} mainScore={el.val.toLocaleString(undefined, { minimumFractionDigits: 2 }) + '€'} subScore="n/d" />
        ));
        {/*
            name: el.name,
            amount: el.val.toLocaleString(undefined, { minimumFractionDigits: 2 }) + '€',
            text: this.le.card.entries[el.name].text,
            subText: this.le.card.entries[el.name].subText
        */}


        /* should the filtering be implemented by BE ?
        const entries = this.state.entries.filter(function (el, idx) {
            return Object.entries(this.configs.filters).every(([flt, fltObj]) => (el[fltObj.idx].indexOf(this.state.filters[flt]) > -1), this);
        }, this);
        */
        //#endregion Data Structures

        let modal;
        switch (this.state.modalType) {
            case 1:
                {
                    const le = this.le.modify;
                    //let buttons = [{ class: "bigger", type: "confirm", text: le.button, click: ((ev) => (this.modalClick(ev, true))) }];
                    const opts = Object.entries(this.le.states).map(([val, txt]) => ({ value: val, text: txt }));

                    modal = (

                        <UIPopup className="" onCancel={(ev) => (this.modalClick(ev, false))} title={le.title} buttons={[<UIButton key="btn" className="confirm" text={le.button} onClick={(ev) => this.modalClick(ev, true)} />]}>
                            <UISelect key="sel" name="status" label={le.description} options={opts} value={this.state.modalState} onChange={this.modalChange} />
                        </UIPopup>
                    );



                    /*<ModalBox width="32%" className="titleThin" title={le.title} buttons={buttons} onClose={((ev) => (this.modalClick(ev, false)))}>
                            <div className="row">
                                <ULabelFlat width="35%" textClass="bold" value={le.description} />
                                <USelectFlat name="status" width="40%" source={this.state.modalReference}
                                    selection={this.state.modalState} options={opts} onChange={this.modalChange} />
                            </div>
                        </ModalBox>*/
                }
                break;
            default:
                modal = (<div />);
                break;
        }

        let pageFilters = Object.entries(this.configs.filters).map(([key, val]) => {
            if (key == 'response') {
                let options = Object.entries(this.le.states).map((a, b) => ({ value: a[0], text: a[1] }));
                options.unshift({ value: "", text: val.text });
                return <UISelect key={key} name={key} onChange={this.filtersChange} value={this.state.filters[key]} hint={val.text} options={options}/>
            }
            else {
                return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={this.state.filters[key]} hint={val.text} />
            }
        });
        pageFilters.push(<UIDownload title={this.le.list.button} onClick={this.downloadExcel} />);

        return (<div className="page-countersigns">

            <PageTitle icon="../images/mainMenu/Contrassegni.png" title={Languages.getSection('Main').menuLabels.countersigns} />
            <div className="page-content">


                <UISummary>
                    <UISummaryWidgetBar>
                        {totals}
                    </UISummaryWidgetBar>                    
                </UISummary>

                <UIFilterPanel>
                    {pageFilters}
                </UIFilterPanel>

                <UIDataTable
                     header={this.header}
                     entries={this.state.entries}
                     listKey={this.listKey}
                     managers={this.state.managers}
                     navigation={this.state.navigation} />

            </div>

            {/*        <div className="container-fluid">
                        <div className="row">
                            <div className="col-4">
                                <UGrandTotals title={this.le.card.title} totals={totals} />
                            </div>
                            <div className="col-8">
                                <CountersignsFilters section="filters" title={this.le.filters.title} filters={this.configs.filters}
                                    data={this.state.filters} onChange={this.filtersChange} onClick={this.filterClick} />
                                <div className="container-fluid ucard">
                                    <div className="row">
                                        <UTitleFlat text={this.le.list.listTitle} />
                                        <UListButtonFlat data={btnData} colClass="right up variation" onClick={this.downloadExcel} />
                                    </div>
                                    <UItemsList listId="CountersignsItemsList" listKey={this.listKey} header={this.header}
                                        entries={this.state.entries} managers={this.state.managers} navigation={this.state.navigation} />
                                </div>
                            </div>
                        </div>
                    </div>*/}

                {modal}
            </div>);
    }
}

